import React, { useEffect, useState } from "react";
import { Button, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import instance from "../../Utils/api";
import { useNavigate, useParams } from "react-router-dom";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { toast } from "react-toastify";
import CommonTable from "../../Admin/components/Common_table";

const ApprovedOrderDetails = () => {
  const [paymentsData, setPaymentsData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const navigate = useNavigate();
  const { id } = useParams();
  const [totalpages, setTotalPages] = useState();
  const [currentPage, setCurrentPages] = useState(1);
  const [totalCount, setTotalcount] = useState();
  const rowsperpage = 10;

  const columns = [
    { label: "S.No", field: "sno",  },
    { label: "Order", field: "Bannerimage",  },
    { label: "Quantity", field: "items",  },
    { label: "Ordered Date", field: "orderdate",  },
    { label: "Status", field: "Status",  },
  ];

  const fetchOrderById = async (id) => {
    try {
      const response = await instance.get(
        `/Payment/getPaymentById?payment_id=${id}`
      );
      const orderDetails = response?.data?.data?.order_id?.sub_orders.map(
        (order, index) => ({
          sno: index + 1,
          Bannerimage: order?.design_id?.picture,
          orderdate: order?.createdAt
            ? new Date(order?.createdAt).toLocaleDateString()
            : "---",
          items: order?.quantity,
          Status: [
            "Uassigned",
            "Assigned",
            "In Payment",
            "Acquisition",
          ].includes(order?.status)
            ? "In Progress"
            : order?.status,
        })
      );
      setPaymentsData(response.data.data);
      setTableData(orderDetails);
      setTotalPages(response?.data?.totalPages);
      setCurrentPages(response?.data?.currentPage);
      setTotalcount(response?.data?.total);
    } catch (err) {
      console.log(err);
    }
  };


  useEffect(() => {
    fetchOrderById(id);
  }, [id]);

  return (
    <React.Fragment>
      <section className="mycart">
        <div className="mycart-title">
          <Button onClick={() => navigate("/profile/approve-pay")}>
            <KeyboardBackspaceIcon />
            Back
          </Button>
          <Typography variant="h4">Pay/Approve</Typography>
        </div>
        <React.Fragment>
          <section className="add-order">
            <div className="payment-info">
              <Typography variant="h3">
                {paymentsData?.for === "Order"
                  ? "Order Payment Info"
                  : "Consultation Payment Info"}
              </Typography>
            </div>
            <hr style={{ margin: "8px 0px" }} />
            <Grid
              container
              spacing={2}
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-start",
              }}
            >
              <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 9 }}>
                <div className="order-content-text">
                  <Typography variant="h5">
                    {paymentsData?.for === "Order"
                      ? "Order Details"
                      : "Consultation Details"}
                  </Typography>
                </div>
                <div className="add_emloyee-content">
                  <div className="add_emloyee-content-text">
                    <Typography variant="h5">
                      {paymentsData?.for === "Order"
                        ? "Order id"
                        : "Order id"}
                    </Typography>
                    <Typography>
                      {paymentsData?.for === "Order"
                        ? paymentsData?.order_id?.order_id
                        : paymentsData?.consultation_id?.order_id}
                    </Typography>
                  </div>
                  <div className="add_emloyee-content-text">
                    <Typography variant="h5">
                      {paymentsData?.for === "Order"
                        ? "Customer Name"
                        : "Consultation Type"}
                    </Typography>
                    <Typography>
                      {paymentsData?.for === "Order"
                        ? paymentsData?.order_id?.address?.name
                        : paymentsData?.consultation_id?.consultation_type}
                    </Typography>
                  </div>
                  <div className="add_emloyee-content-text">
                    <Typography variant="h5">
                      {paymentsData?.for === "Order"
                        ? "Assigned Person"
                        : "Assigned Person"}
                    </Typography>
                    <Typography>
                      {paymentsData?.for === "Order"
                        ? paymentsData?.order_id?.assigned_to?.name
                        : paymentsData?.consultation_id?.assigned_to?.name}
                    </Typography>
                  </div>
                </div>
                <div className="add_emloyee-content">
                  <div className="add_emloyee-content-text">
                    <Typography variant="h5">
                      {paymentsData?.for === "Order"
                        ? "Order Status"
                        : "Consultation Status"}
                    </Typography>
                    <Typography>
                      {paymentsData?.for === "Order"
                        ? [
                          "Uassigned",
                          "Assigned",
                          "In Payment",
                          "Acquisition",
                        ].includes(paymentsData?.order_id?.status)
                          ? "In Progress"
                          : paymentsData?.order_id?.payment_status
                        : ["Uassigned", "Assigned", "In Payment"].includes(
                          paymentsData?.consultation_id?.status
                        )
                          ? "Booked"
                          : paymentsData?.consultation_id?.payment_status}
                    </Typography>
                  </div>
                  <div className="add_emloyee-content-text">
                    <Typography variant="h5">
                      {paymentsData?.for === "Order"
                        ? "Ordered Date"
                        : "Consultation Date"}
                    </Typography>
                    <Typography>
                      {paymentsData?.for === "Order"
                        ? paymentsData?.order_id?.createdAt
                          ? new Date(paymentsData.order_id.createdAt).toLocaleString()
                          : "---"
                        : paymentsData?.consultation_id?.consultation_date
                          ? new Date(
                            paymentsData.consultation_id.consultation_date
                          )
                            .toISOString()
                            .split("T")[0]
                          : "---"}
                    </Typography>
                  </div>
                </div>
              </Grid>
            </Grid>
            <hr style={{ margin: "8px 0px" }} />
            <Grid
              container
              spacing={2}
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-start",
              }}
            >
              <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 9 }}>
                <div className="order-content-text">
                  <Typography variant="h5">Payment Details</Typography>
                </div>
                <div className="add_emloyee-content">
                  <div className="add_emloyee-content-text">
                    <Typography variant="h5">Payment For</Typography>
                    <Typography>{paymentsData?.for}</Typography>
                  </div>
                  <div className="add_emloyee-content-text">
                    <Typography variant="h5">Payment Date</Typography>
                    <Typography>
                      {paymentsData?.createdAt
                        ? new Date(paymentsData?.createdAt).toLocaleString()
                        : "---"}
                    </Typography>
                  </div>
                  <div className="add_emloyee-content-text">
                    <Typography variant="h5">Payment Status</Typography>
                    <Typography>
                      {paymentsData?.for === "Order"
                        ? paymentsData?.order_id?.payment_status
                        : paymentsData?.consultation_id?.payment_status}
                    </Typography>
                  </div>
                </div>
                <div className="add_emloyee-content">
                  <div className="add_emloyee-content-text">
                    <Typography variant="h5">Payment Amount</Typography>
                    <Typography>
                      ₹
                      {paymentsData?.for === "Order"
                        ? paymentsData?.order_id?.payment_amount
                        : paymentsData?.amount}
                    </Typography>
                  </div>
                  <div className="add_emloyee-content-text">
                    {paymentsData?.for === "Order" ? (
                      <>
                        <Typography variant="h5">Amount Paid</Typography>
                        <Typography>
                          ₹{paymentsData?.order_id?.paid_amount}
                        </Typography>
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="add_emloyee-content-text">
                    {paymentsData?.for === "Order" ? (
                      <>
                        <Typography variant="h5">Pending Amount</Typography>
                        <Typography>
                          ₹{paymentsData?.order_id?.pending_amount}
                        </Typography>
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </Grid>
            </Grid>
            {paymentsData?.for === "Order" ? (
              <hr style={{ margin: "8px 0px" }} />
            ) : (
              ""
            )}
            {paymentsData?.for === "Order" ? (
              <>
                <div className="order-content-text">
                  <Typography variant="h5">Booking Details</Typography>
                </div>
                <CommonTable
                  rows={tableData}
                  columns={columns}
                  totalpages={totalpages}
                  rowsperpage={rowsperpage}
                  totalCount={totalCount}
                  currentPage={currentPage}
                  setCurrentPages={setCurrentPages}
                />
              </>
            ) : (
              ""
            )}
            <div className="approve-btn-container">
              <Button
                className="approve-pay-btn"
                onClick={() => {
                  if (paymentsData?.payment_link) {
                    window.open(paymentsData?.payment_link, "_blank");
                  } else {
                    toast.error("Payment Unavailable");
                  }
                }}
                disabled={!paymentsData?.payment_link}
              >
                {paymentsData?.payment_link ? "Pay/Approve" : "Unavailable"}
              </Button>
            </div>
          </section>
        </React.Fragment>
      </section>
    </React.Fragment>
  );
};

export default ApprovedOrderDetails;
